import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import HomeStart from "./HomeStart/HomeStart";
import Text from "./Text/Text";
import { selectCurrentSpaceId } from "slices/spaceSlice";
import { selectCurrentActiveEffice } from "slices/sharedSelectors";

const MainContent = () => {
  window.efs_debug && window.log("MAIN CONTENT RENDERED");
  const currActiveEffice = useSelector(selectCurrentActiveEffice);
  const currentSpaceId = useSelector(selectCurrentSpaceId);

  useEffect(() => {
    if (currActiveEffice)
      document.title = "EfficeSpace - " + currActiveEffice.content;

    return () => (document.title = "EfficeSpace");
  }, [currActiveEffice]);

  return (
    <div
      className={`fluid-main-content ${currentSpaceId ? "space-active" : ""}`}
    >
      {currActiveEffice ? <Text /> : <HomeStart />}
    </div>
  );
};

export default MainContent;
